import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["defaultValue", "onChange", "id", "variant", "label", "getOptionLabel", "inputProps", "error", "helperText", "noOptionsText"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useLazyQuery } from '@apollo/client';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '../../../atoms/TextField';
import { CITIES_QUERY } from '../../../../apollo/queries';
import { useTranslation } from '../../../../config/i18n';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var CitiesAutocomplete = function CitiesAutocomplete(_ref) {
  var defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    id = _ref.id,
    variant = _ref.variant,
    label = _ref.label,
    getOptionLabel = _ref.getOptionLabel,
    inputProps = _ref.inputProps,
    error = _ref.error,
    helperText = _ref.helperText,
    noOptionsText = _ref.noOptionsText,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    cityInput = _React$useState2[0],
    setCityInput = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    open = _React$useState4[0],
    setOpen = _React$useState4[1];
  var _React$useState5 = React.useState([_objectSpread({}, defaultValue)]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    options = _React$useState6[0],
    setOptions = _React$useState6[1];
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var handleCompleteFetchCities = function handleCompleteFetchCities(citiesData) {
    if (citiesData && citiesData.filterCities && citiesData.filterCities[0]) {
      setOptions(citiesData.filterCities ? _toConsumableArray(citiesData.filterCities) : []);
    }
  };
  var _useLazyQuery = useLazyQuery(CITIES_QUERY, {
      variables: {
        query: cityInput
      },
      onCompleted: handleCompleteFetchCities
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    fetchCities = _useLazyQuery2[0],
    citiesLoading = _useLazyQuery2[1].loading;

  //   const loading = open && citiesLoading;

  // React.useEffect(() => {
  //   if (citiesData && citiesData.filterCities) {
  //     setOptions([...citiesData.filterCities]);
  //   }
  // }, [citiesData]);

  React.useEffect(function () {
    if (cityInput) {
      fetchCities();
    }
  }, [cityInput]);
  return /*#__PURE__*/_jsx(Autocomplete, _objectSpread({
    onChange: onChange,
    id: id,
    open: open,
    onOpen: function onOpen() {
      setOpen(true);
    },
    onClose: function onClose() {
      setOpen(false);
    },
    isOptionEqualToValue: function isOptionEqualToValue(option, val) {
      return option.name === val.name;
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.country ? "".concat(option.name, ", ").concat(option.country.name) : option.name;
    },
    noOptionsText: t('common:search_location')
    // includeInputInList
    ,
    filterSelectedOptions: true,
    options: options,
    loading: citiesLoading,
    defaultValue: defaultValue,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread(_objectSpread({}, inputProps), {}, {
        error: error,
        helperText: helperText
      }, params), {}, {
        label: label,
        fullWidth: true,
        variant: variant,
        onChange: function onChange(e) {
          return setCityInput(e.target.value);
        },
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          endAdornment: /*#__PURE__*/_jsxs(_Fragment, {
            children: [citiesLoading ? /*#__PURE__*/_jsx(CircularProgress, {
              color: "inherit",
              size: 20
            }) : null, params.InputProps.endAdornment]
          })
        })
      }));
    }
    // renderOption={(option) => {
    //   const optionElement =
    //     option.country && option.country.name ? (
    //       <div>
    //         <strong>{option.name}</strong>, {option.country.name}
    //       </div>
    //     ) : (
    //       <div>{option.name}</div>
    //     );
    //   return optionElement;
    // }}
  }, props));
};
CitiesAutocomplete.defaultProps = {
  onChange: function onChange() {}
};
export default CitiesAutocomplete;